<template>
    <base-page class="comp-page-device" :title="$t('l.remove_device_list')">
        <Row slot="extra" class=" margin-bottom-10" :gutter=8 type="flex" justify="end">
            <Col>
                <Button type="primary" @click="loadData(table.page.current)">
                    {{$t('l.fresh')}}
                </Button>
            </Col>
            <Col class="margin-left-5">
                <Input  v-model="table.page.keyword" search
                       :placeholder="$t('l.remark67')" @on-change="searchBlur" @on-search="loadData(1)"/>
                <Input hidden style="display:none"/>
            </Col>
        </Row>
        <Row>
            <Table   stripe border :columns="getColumns" :data="table.data" :loading="table.loading">
            </Table>
        </Row>
        <template>
            <Row type="flex" justify="center">
                <Col>
                    <Page size="small"
                          :current="table.page.current"
                          :page-size="table.page.size"
                          :total="table.page.total"
                          :page-size-opts="table.page.sizeOptions"
                          show-elevator show-sizer show-total
                          @on-page-size-change="($event)=>{table.page.size=$event;loadData(1)}"
                          @on-change="loadData($event)">
                    </Page>
                </Col>
            </Row>
        </template>
        <!-- 详情 -->
        <template>
            <LgModal :title="$t('l.detail')" :show="modal.show" confirm-text="关闭" @on-submit="modal.show=false"  :show-cancel="false">
                <div class="modal-content">
                    <p><span>{{$t('l.elevator_name')}}：</span>{{modal.device.name}}</p>
                    <p><span>{{$t('l.device_model')}}：</span>{{modal.device.model}}</p>
                    <p><span>{{isZhongFuCompany?$t("l.device_unique_id"):$t('l.device_number')}}：</span>{{modal.device.code}}</p>
                    <p><span>{{$t('l.remove_user')}}：</span>{{modal.device.real_name}}</p>
                    <p><span>{{$t('l.remove_user_mobile')}}：</span>{{modal.device.mobile}}</p>
                    <p><span>{{$t('l.community_name')}}：</span>{{modal.device.community_name}}</p>
                    <p><span>{{$t('l.manufacturer')}}：</span>{{modal.device.brand?modal.device.brand:modal.device.factory_name}}</p>
                        <p><span>{{$t('l.mt_person')}}：</span>
                            <template v-if="modal.device.j_mt_workers">
                                <template v-for="d in modal.device.j_mt_workers">
                                    {{d.name}}
                                </template>
                            </template>
                            <template v-else>
                                {{$t("l.remark194")}}
                            </template>
                        </p>
                    <p><span>{{$t('l.terminal_id')}}：</span>{{modal.device.terminal_id?modal.device.terminal_id:$t('l.unbound')}}</p>
                    <p><span>{{$t('l.delete_time')}}：</span>{{modal.device.update_time}}</p>
                    <p><span>{{$t('l.create_time')}}：</span>{{new Date(modal.device.create_time).pattern("yyyy-MM-dd HH:mm:ss")}}</p>
                    <p><span>{{$t('l.location')}}：</span>{{modal.device.address}}</p>
                </div>
            </LgModal>
        </template>
    </base-page>
</template>

<script>
    import util from '@/libs/util';
    import BasePage from "../my-components/base-page";
    import LgModal from "../my-components/lg-modal";
    export default {
        name: "page_remove_device",
        components:{BasePage,LgModal},
        props:{

        },
        data(){
            return{
                table:{
                    data: [],
                    page: {
                        current: 1,  // 当前页码
                        size: 24, // 每页个数
                        sizeOptions: [12, 18, 24, 48, 60],
                        total: 0,
                        sortKey: 'dd.id',
                        sortMethod: 'desc',
                        keyword: ''
                    },
                    loading: false,
                },
                modal:{
                    show:false,
                    device:{}
                }
            }
        },
        methods:{
            loadData(page = 1) {
                    let params = {
                        page: page || this.table.page.current,
                        size: this.table.page.size,
                        orderKey: this.table.page.sortKey,
                        orderMethod: this.table.page.sortMethod,
                        keyword: this.table.page.keyword,
                        noStatus:false
                    };
                    this.table.loading = true;
                    util.ajax.post('/device/remove_list', params).then(res => {
                        this.setPage(res.data);
                    })
            },
            pageSizeChange(){},
            setPage(pageInfo) {
                if (pageInfo) {
                    pageInfo.list.forEach(device => {
                        util.parseJSONResult(device);
                    })
                    this.table.data = pageInfo.list;
                    this.table.page.current = pageInfo.pageNumber;
                    this.table.page.total = pageInfo.totalRow;
                }
                this.table.loading = false;
            },
            searchBlur() {
                if (!this.table.page.keyword) this.loadData(1);
            },
        },
        computed:{
          isZhongFuCompany(){
            let conmpany = this.$store.state.user.user.company;
            return conmpany.id === 154 || conmpany.pid === 154;
          },
            getColumns(){
              // 2025年10月28日 王欢 按照姜铎和闵总沟通后的要求将中富电梯的厂家代码显示全部替换成电梯唯一工号
              let conmpany = this.$store.state.user.user.company;
              let isZhongFuCompany = conmpany.id === 154 || conmpany.pid === 154;
                return [
                    {
                        title: 'ID',
                        align: 'center',
                        width: 100,
                        key: 'id'
                    },
                    {
                        title:  this.$t('l.elevator_name'),
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title:  this.$t('l.device_model'),
                        align: 'center',
                        width: 140,
                        key: 'model'
                    },
                    {
                        title:  isZhongFuCompany?this.$t('l.device_unique_id'):this.$t('l.device_number'),
                        align: 'center',
                        width: 140,
                        key: 'code'
                    },
                    {
                        title:  this.$t('l.location'),
                        align: 'center',
                        key: 'address'
                    },
                    {
                        title:  this.$t('l.remove_user'),
                        align: 'center',
                        key: 'real_name'
                    },
                    {
                        title:  this.$t('l.remove_user_mobile'),
                        align: 'center',
                        key: 'mobile',
                        width: 150,
                    },
                    {
                        title:  this.$t('l.delete_time'),
                        align: 'center',
                        width: 180,
                        key: 'update_time'
                    },
                    {
                        title:  this.$t('l.operation'),
                        key: 'action',
                        align: 'center',
                        width: 200,
                        render: (h, params) => {
                            return h('ButtonGroup', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: "8px"
                                    },
                                    on: {
                                        click: () => {
                                            this.modal.show = true;
                                            this.modal.device = params.row
                                        }
                                    }
                                }, this.$t('l.detail')),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title:this.$t("l.warn"),
                                                content:this.$t("l.remark227"),
                                                onOk:()=>{
                                                    util.ajax.get("/device/recovery_remove",{
                                                        params:{
                                                            id:params.row.id
                                                        }
                                                    }).then(res=>{
                                                        if (!res.code){
                                                            this.loadData(1);
                                                            this.$Message.success($t('l.remark166'));
                                                        } else{
                                                            this.$Message.error($t('l.4023'));
                                                        }
                                                    })
                                                },
                                            })
                                        }
                                    }
                                },this.$t('l.resume')),
                            ]);
                        }
                    }
                ]
            }
        },
        created(){
            this.loadData(1);
        }

    }
</script>

<style scoped lang="less">
    .modal-content{
        p{
            font-size: 16px;
            span{
                font-weight: 600;
            }
        }
    }
</style>